<app-header></app-header>
<app-toolbar></app-toolbar>


<div class="bg-banner"></div>
<div class="h-full px-7 py-4 box-border main-container">

  <section class="main-card-container">
    <div class="flex flex-col mb-7">
      <div class=" flex justify-center align-middle w-full logo-container">
        <img src="../../../assets/img/logo_cangas_aventura.png" alt="logo cangas aventura">
      </div>
      <div class="bg-[#27368A] rounded-2xl py-3 grid grid-cols-5 gap-3 justify-center align-middle items-center w-full today-amount-container">
        <div
          class="col-span-3 bg-white rounded-2xl flex flex-col ml-6 px-4 py-4 justify-center align-middle items-center ">
          <p class="text-[#27368A] font-bold text-xl">Turno</p>
          <p class="text-red-600 font-bold text-2xl">{{ totalSellTurn }}€</p>
        </div>
        <div class="col-span-2 flex justify-center align-middle items-center mr-6">
          <app-toolbar-item *ngFor="let item of cashItems" [item]="item" class="w-full"></app-toolbar-item>
        </div>
      </div>

    </div>
    <div class="flex flex-col max-h-full">
      <div class="flex justify-between">
        <h2 class="text-[#27368A] font-medium text-xl m-2">Próximas actividades</h2>
        <button class="bg-[#429DCF] text-white text-[20px] font-[600] rounded-[12px] px-[18px] py-[5px] flex gap-2 items-center mb-3" routerLink="/panel/planning">Ir a planning</button>
      </div>
      <div class="h-full border-2 border-[#27368A] rounded-2xl">
        <app-table-planning *ngFor="let bookingService of bookingServicesPlanning;let last = last"
          [bookingServiceData]="bookingService" [last]="last"></app-table-planning>
        <div *ngIf="bookingServicesPlanning == null || bookingServicesPlanning.length === 0"
          class="flex justify-center items-center w-full bg-slate-200 border border-dashed border-slate-500 rounded-xl hover:cursor-pointer  p-40">
          <h1 class="text-center text-2xl text-slate-500">
            Añade una nueva actividad<br>
          </h1>
        </div>
      </div>
    </div>
  </section>
  <ng-container *ngIf="validatePermission('see_charts')">
    <div class="card flex flex-wrap justify-content-between charts-card-container">
      <div class="w-[100%] xl:w-[45%] m-2 xl:m-5 bg-white overflow-hidden rounded-[15px] border-2 border-[#f0f0f0]">
        <div id="chart_pie" class="chart" ></div>
      </div>
      <div class="w-[100%] xl:w-[45%] m-2 xl:m-5 bg-white overflow-hidden rounded-[15px] border-2 border-[#f0f0f0]">
        <div id="chart_ring" class="chart" ></div>
      </div>
      <div class="w-[100%] xl:w-[45%] m-2 xl:m-5 bg-white overflow-hidden rounded-[15px] border-2 border-[#f0f0f0]">
        <div id="chart_columns" class="chart" ></div>
      </div>
      <div class="w-[100%] xl:w-[45%] m-2 xl:m-5 bg-white overflow-hidden rounded-[15px] border-2 border-[#f0f0f0]">
        <div id="chart_bars" class="chart" ></div>
      </div>
      <div class="w-[100%] xl:w-[45%] m-2 xl:m-5 bg-white overflow-hidden rounded-[15px] border-2 border-[#f0f0f0]">
        <div id="chart_columns2" class="chart" ></div>
      </div>
      <div class="w-[100%] xl:w-[45%] m-2 xl:m-5 bg-white overflow-hidden rounded-[15px] border-2 border-[#f0f0f0]">
        <div id="chart_bars2" class="chart" ></div>
      </div>
    </div>
  </ng-container>
</div>
